export default (deviceType, viewport) => {
	return deviceType === 'mobile'
			|| (deviceType === 'tablet' && viewport.height > viewport.width)
			|| viewport.width < 900;
};



// WEBPACK FOOTER //
// ./src/utils/checkMobile.js